import React, { useState, useEffect } from 'react';
import Logo from '../images/ftb_is_logo_trp.png';

export default function NavigationBar() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('theme');
      return saved ? saved === 'dark' : true;
    }
    return true;
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  const toggleDarkMode = () => setIsDark(!isDark);

  const NavItem = ({ href, label }) => {
    // Determine active line link logic route
    const isActive = typeof window !== 'undefined' &&
      (window.location.pathname === href || (window.location.pathname === '/' && href === '/landing'));

    return (
      <li className="nav-item mt-2 mt-md-0 position-relative">
        <a
          className={`nav-link fw-semibold px-2 px-md-1 position-relative ${isActive ? 'text-primary' : ''}`}
          style={{
            fontSize: '1rem',
            transition: 'color 0.3s ease',
            color: isActive ? 'var(--ftb-primary)' : 'var(--ftb-text-muted)',
            letterSpacing: '0.3px'
          }}
          onMouseOver={e => !isActive && (e.target.style.color = 'var(--ftb-primary)')}
          onMouseOut={e => !isActive && (e.target.style.color = 'var(--ftb-text-muted)')}
          href={href}
        >
          {label}
          {isActive && (
            <span
              className="position-absolute bottom-0 start-50 translate-middle-x bg-primary"
              style={{ width: '20px', height: '2px', borderRadius: '10px', marginBottom: '-4px' }}
            />
          )}
        </a>
      </li>
    );
  };

  return (
    <>
      <div className="navbar navbar-expand-md py-3 sticky-top" style={{ transition: 'all 0.3s ease', boxShadow: 'var(--ftb-card-shadow)' }}>
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/landing">
            <img className="img-fluid" width="160" src={Logo} alt="landingimage" style={{ maxWidth: '160px', height: 'auto', filter: isDark ? 'brightness(1.1) contrast(1.1)' : 'none', transition: 'filter 0.3s' }} />
            <div className="d-none d-lg-flex flex-column ms-3 ps-3 border-start" style={{ borderColor: 'var(--ftb-border)', transition: 'border-color 0.3s' }}>
              <span className="fw-bold" style={{ fontSize: '0.8rem', letterSpacing: '1px', color: 'var(--ftb-text)', textTransform: 'uppercase' }}>
                FTB Innosphere
              </span>
              <span className="fw-medium" style={{ fontSize: '0.75rem', letterSpacing: '0.5px', color: 'var(--ftb-text-muted)' }}>
                Innovative Solutions
              </span>
            </div>
          </a>

          <div className="d-flex align-items-center ms-auto order-md-last">
            {/* Dark Mode Toggle */}
            <button
              onClick={toggleDarkMode}
              className="btn btn-link p-2 ms-2 ms-md-4 border-0 shadow-none text-decoration-none d-flex align-items-center justify-content-center"
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'var(--ftb-bg-alt)',
                fontSize: '1.2rem',
                cursor: 'pointer',
                transition: 'var(--transition)'
              }}
              title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
              {isDark ? '☀️' : '🌙'}
            </button>

            <button className="navbar-toggler ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <div className="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
            <ul className="navbar-nav align-items-center gap-2 gap-md-4 me-md-4">
              <NavItem href="/landing" label="Home" />
              <NavItem href="/service" label="Services" />
              <NavItem href="/career" label="Career" />
              <NavItem href="/contact" label="Contact" />
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

